export const SETTINGS_VISIBILITY = {
    workspaceOwner: 'workspaceOwner',
    hasAccount: 'hasAccount',
    whiteLabel: 'whiteLabel',
    manageBilling: 'manageBilling',
}
